import MetricData from "src/shared/models/metric-data";

export interface QMEvaluatorPerformanceData {
    DataRows: QMEvaluatorPerformanceDataRow[];
}

export interface QMEvaluatorPerformanceDataRow {
    Name: string;
    Completed: CompletedData;
    Appealed: AppealedData;
    ID: string;

    GroupID: number;
    FilterableID: string;
}

export interface CompletedData {
    CompletedDisplayValue: string;
    CompletedValue: number;
    MetricDatas: Map<string, MetricData>;
    ChartData: Map<string, string>;
}

export interface AppealedData {
    AppealedDisplayValue: string;
    AppealedMetricData: MetricData;
}

export interface MetricDataValue {
    total: number;
    completed: number;
    pending: number;
    expired: number;
    deleted: number;
    replaced: number;
    appealed: number;
    appealedExpired: number;
    completedDeleted: number;
}

export interface ChartLegends {
    label: string;
    key: string;
    color: string;
    toggleLegend: boolean;
    className: string;
}

export interface LegendDataValues {
    [key: string]: number;
}

export interface EvaluatorDropdownOption {
    id: number;
    label: string;
}

export const ComparisonChartColors = {
    completed: "rgba(153, 202, 189, 1)",
    pending: "rgba(73, 89, 164, 1)",
    appealed: "rgba(159, 139, 199, 1)",
    deleted: "rgba(106, 70, 164, 1)",
    replaced: "rgba(79, 129, 146, 1)",
    expired: "rgba(157, 169, 83, 1)",
    appealedExpired: "rgba(168, 174, 180, 1)",
    completedDeleted: "rgba(158, 75, 150, 1)"
}

export enum DisplayViewOption {
    TABLE,
    COMPLETED_EVALUATIONS_TREND,
    COMPARISON
}

export const ChartUIPostionValues = {
    dataLabelYPosition: 12.2,
    dataLabelXPosition: -.5,
    markerRadius: 7,
    svgMarkerWidth: 50,
    svgMarkerHeight: 50,
    svgdataLabelXPosition: 19,
    svgdataLabelYPosition: -1
}

export interface LineChartDataValues {
    [key: string]: string;
}